import { gql } from '@apollo/client'

export const SUBMIT_CLASSIFICATION_BATCH = gql`
  mutation SubmitClassificationBatch($input: SubmitClassificationBatchInput!) {
    submitClassificationBatch(input: $input) {
      __typename
      ... on SubmitClassificationBatchResult {
        success
        acceptedBoxes {
          id
          sourceImageUrl
          minX
          maxX
          minY
          maxY
          metaClass
          isHumanAdded
          isHumanDeleted
          isFlagged
          flagged {
            level
            moreInfo
            reasons {
              type
              reason
              resolved
            }
          }
          leasedById
          leasedAt
        }
        rejectedBoxes {
          id
          sourceImageUrl
          minX
          maxX
          minY
          maxY
          metaClass
          isHumanAdded
          isHumanDeleted
          isFlagged
          flagged {
            level
            moreInfo
            reasons {
              type
              reason
              resolved
            }
          }
          leasedById
          leasedAt
        }
        undoAction {
          mutationName
          variablesPayload
        }
        redoAction {
          mutationName
          variablesPayload
        }
      }
    }
  }
`
